import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { WebApiService } from '../service/web-api.service';
import { environment } from '../../environments/environment';

@Injectable()
export class DisplayService {

  constructor(private webApiServece: WebApiService) { }

  /**
   * 画面表示情報取得
   */
  execAuthDisplayInfo(screenId: string): Observable<any> {
    const requestParam = { 'screen_id' : screenId };
    return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/display-info', requestParam)
      .map(cfResponse => {
        return cfResponse.data;
      })
      .catch(error => {
        return Observable.throw(error);
      });
  }
}
